export const roles = {
  ADMIN: "ADMIN",
  REQUESTER: "REQUESTER",
  REVIEWER: "REVIEWER",
  AUDITOR: "AUDITOR",
  LEADERSHIP: "LEADERSHIP",
  "PROJECT MANAGER": "PROJECT MANAGER",
};

export const permissions = {
  [roles.ADMIN]: ["dashboard", "survey", "assessment", "access", "otp"],
  [roles.REQUESTER]: ["dashboard", "survey", "assessment", "access", "otp"],

  [roles.REVIEWER]: ["dashboard"],
  [roles.AUDITOR]: ["dashboard"],
  [roles.LEADERSHIP]: ["dashboard", "leadership"],
  [roles["PROJECT MANAGER"]]: ["dashboard"],
};
